import { EventEmitter } from '@angular/core';
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
var CasePracticePAndOPreviousComponent = (function () {
    function CasePracticePAndOPreviousComponent(commonService, apiService, route, router) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.onGoToNextStep = new EventEmitter();
        this.assetsRoute = "../../assets";
    }
    CasePracticePAndOPreviousComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        var that = this;
        this.glBoxShow = false;
        this.wlnBoxShow = false;
        this.fkkBoxShow = false;
        this.qfBoxShow = false;
        this.icon0Show = false;
        this.icon1Show = false;
        this.icon2Show = false;
        this.icon3Show = false;
        this.nextStepShow = false;
        this.description1Show = false;
        this.description2Show = false;
        this.timeTableShow = false;
        this.earthShow = false;
        console.log('exerciseId:' + this.exerciseId);
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/pnoQuestion/' + this.exerciseId
        }).subscribe(function (result) {
            _this.status = result.status;
            // 如果是访客永远从头开始情景模拟剧情
            if (_this.userType) {
                _this.status = 0;
            }
            if (_this.status == 0) {
                _this.step = 0;
                _this.peopleNumber = 0;
                _this.taskNumber = 0;
                setTimeout(function () {
                    that.nextStepShow = true;
                }, 1000);
                $('#wrap').fadeTo('slow', 0.3, function () {
                    $(this).css('background-image', 'url("../../assets/picture/casepracticepando/bg1.png")');
                }).fadeTo('slow', 1);
                setTimeout(function () {
                    that.clickable = true;
                }, 2000);
            }
            else if (_this.status == 5) {
                _this.step = 3;
                _this.taskNumber = 0;
                setTimeout(function () {
                    that.description2Show = true;
                }, 1000);
                $('#wrap').fadeTo('slow', 0.3, function () {
                    $(this).css('background-image', 'url("../../assets/picture/casepracticepando/bg1.png")');
                }).fadeTo('slow', 1);
                setTimeout(function () {
                    that.clickable = true;
                }, 2000);
            }
            else if (_this.status == 10) {
                _this.step = 5;
                _this.timeTableShow = true;
                $('#wrap').fadeTo('slow', 0.3, function () {
                    $(this).css('background-image', 'url("../../assets/picture/casepracticepando/China.png")');
                }).fadeTo('slow', 1);
                setTimeout(function () {
                    that.clickable = true;
                }, 1000);
            }
        });
    };
    CasePracticePAndOPreviousComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
        document.oncontextmenu = function (e) {
            e.preventDefault();
        };
    };
    CasePracticePAndOPreviousComponent.prototype.screenClick = function () {
        if (!this.clickable) {
            return;
        }
        var _this = this;
        if (this.step == 0) {
            this.step = 1;
            this.clickable = false;
            this.nextStepShow = false;
            // $('#reviewBox').fadeIn();
            setTimeout(function () {
                _this.description1Show = true;
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 1000);
        }
        else if (this.step == 1) {
            this.clickable = false;
            if (this.peopleNumber == 0) {
                this.peopleNumber = 1;
                this.description1Show = false;
                setTimeout(function () {
                    $('#gl').fadeIn(200);
                    _this.glBoxShow = true;
                    setTimeout(function () {
                        _this.clickable = true;
                    }, 1000);
                }, 1000);
            }
            else if (this.peopleNumber == 1) {
                this.peopleNumber = 2;
                this.glBoxShow = false;
                setTimeout(function () {
                    $('#wln').fadeIn(200);
                    _this.wlnBoxShow = true;
                    setTimeout(function () {
                        _this.clickable = true;
                    }, 1000);
                }, 1000);
            }
            else if (this.peopleNumber == 2) {
                this.peopleNumber = 3;
                this.wlnBoxShow = false;
                setTimeout(function () {
                    $('#fkk').fadeIn(200);
                    _this.fkkBoxShow = true;
                    setTimeout(function () {
                        _this.clickable = true;
                    }, 1000);
                }, 1000);
            }
            else if (this.peopleNumber == 3) {
                this.step = 2;
                this.fkkBoxShow = false;
                setTimeout(function () {
                    $('#qf').fadeIn(200);
                    _this.qfBoxShow = true;
                    setTimeout(function () {
                        _this.clickable = true;
                    }, 1000);
                }, 1000);
            }
        }
        else if (this.step == 2) {
            this.step = 3;
            this.clickable = false;
            $('#gl').fadeOut(200);
            $('#wln').fadeOut(200);
            $('#fkk').fadeOut(200);
            $('#qf').fadeOut(200);
            this.qfBoxShow = false;
            this.apiService.ajax({
                'type': 'post',
                'url': '/api/pnoStorePoint/' + this.exerciseId,
                'data': {
                    'pno_store_point_id': 5
                }
            }).subscribe(function (result) { });
            setTimeout(function () {
                _this.description2Show = true;
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 1000);
        }
        else if (this.step == 3) {
            this.clickable = false;
            if (this.taskNumber == 0) {
                this.taskNumber = 1;
                this.description2Show = false;
                $('#wrap').fadeTo('fast', 0.3, function () {
                    $('#wrap').css('background', '#ffffff');
                    // $(this).css('background-image', 'url("../../assets/picture/casepracticepando/bg2.png")');
                    $("#earth").fadeIn(200, function () {
                        _this.icon0Show = true;
                    });
                }).fadeTo('fast', 1);
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }
            else {
                var oldIndex = this.taskNumber - 1;
                var currentIndex = this.taskNumber;
                if (this.taskNumber < 3) {
                    this.taskNumber++;
                }
                else {
                    this.step = 4;
                }
                if (oldIndex == 0) {
                    this.icon0Show = false;
                    this.earthShow = true;
                    setTimeout(function () {
                        // $('#wrap').css('background-image', 'url("../../assets/picture/casepracticepando/China.png")');
                        setTimeout(function () {
                            _this.icon1Show = true;
                            setTimeout(function () {
                                _this.clickable = true;
                            }, 1000);
                        }, 1000);
                    }, 1000);
                }
                else if (oldIndex == 1) {
                    this.icon1Show = false;
                    setTimeout(function () {
                        _this.icon2Show = true;
                        setTimeout(function () {
                            _this.clickable = true;
                        }, 1000);
                    }, 1000);
                }
                else if (oldIndex == 2) {
                    this.icon2Show = false;
                    setTimeout(function () {
                        _this.icon3Show = true;
                        setTimeout(function () {
                            _this.clickable = true;
                        }, 1000);
                    }, 1000);
                }
            }
        }
        else if (this.step == 4) {
            this.clickable = false;
            this.step = 5;
            this.icon3Show = false;
            setTimeout(function () {
                // $('#timeTable').fadeIn(200);
                _this.timeTableShow = true;
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 1000);
            this.apiService.ajax({
                'type': 'post',
                'url': '/api/pnoStorePoint/' + this.exerciseId,
                'data': {
                    'pno_store_point_id': 10
                }
            }).subscribe(function (result) { });
        }
        else if (this.step == 5) {
            this.clickable = false;
            this.apiService.ajax({
                'type': 'post',
                'url': '/api/pnoStorePoint/' + this.exerciseId,
                'data': {
                    'pno_store_point_id': 15
                }
            }).subscribe(function (result) {
                _this.onGoToNextStep.emit(true);
            });
        }
    };
    return CasePracticePAndOPreviousComponent;
}());
export { CasePracticePAndOPreviousComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-p-and-o-previous/case-practice-p-and-o-previous.component.ts.pre-build-optimizer.js